export default {"src":"/_next/static/media/calender.2996189e.svg","height":51,"width":46};